import React from "react";
import "./Experience.css";
const Experience = () => {
	return (
		<div className="experience" id="experience">
			<div className="achievement">
				<div className="circle">6+</div>
				<span>Years </span>
				<span>Experience</span>
			</div>
			<div className="achievement">
				<div className="circle">8+</div>
				<span>Worked </span>
				<span>Projects</span>
			</div>
			<div className="achievement">
				<div className="circle">3</div>
				<span>Companies </span>
				<span>Worked</span>
			</div>
			<div className="achievement">
				<div className="circle">6</div>
				<span>Salesforce </span>
				<span>Certifications</span>
			</div>
		</div>
	);
};

export default Experience;
